import { MenuKey } from 'constant/menu';
import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

type AppNameContextType = {
  appName: MenuKey;
  setAppName: React.Dispatch<React.SetStateAction<MenuKey>>;
};

export const AppNameContext = createContext<AppNameContextType | undefined>(undefined);

export default function AppNameProvider({ children }: { children: React.ReactNode }) {
  const [appName, setAppName] = useState<MenuKey>('dacum');

  const initialValue: AppNameContextType = { appName, setAppName };

  return <AppNameContext.Provider value={initialValue}>{children}</AppNameContext.Provider>;
}

AppNameProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export function useAppName(): AppNameContextType {
  const context = useContext(AppNameContext);
  if (!context) {
    throw new Error('useAppName must be used within an AppNameProvider');
  }
  return context;
}
